import {createSlice } from "@reduxjs/toolkit";



//INITIAL STATE
const initialState ={
    notesView: false,
    foldererView: false,
    
};

const options = {
    name: 'notes',
    initialState: {
       // notesView: false,
        selectedNoteId:"",
        selectedNoteName:"",
        selectedCategory:"",
        selectedSubCategory:"",
        public: null,
        foldererView: false,
        
    },
reducers: {
    getInitialState: state  => 
    initialState,

  /*  openNotesForm: (state) => {
    state.notesView = true;
},*/
    setSelectedNoteId: (state, action) => {
        state.selectedNoteId = action.payload;
    },
    setSelectedNoteName: (state, action) => {
        state.selectedNoteName = action.payload;
    },
    setSelectedCategory: (state, action) => {
        state.selectedCategory = action.payload;
    },
    setSelectedSubCategory: (state, action) => {
        state.selectedSubCategory = action.payload;
    },
        setSelectedNotePrivateStatus: (state, action) => {
        state.public= action.payload;
    },
        changeFoldererView: (state, action) => {
        state.foldererView= !state.foldererView;
    },
            closeFoldererView: (state, action) => {
        state.foldererView= false;
    },
   
},

        

};

export const  noteSlice = createSlice(options);
export const {setSelectedNoteId, setSelectedNoteName, setSelectedCategory, setSelectedNotePrivateStatus,
    setSelectedSubCategory, changeFoldererView, closeFoldererView} = noteSlice.actions;
export default noteSlice.reducer;


